"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-channelinfo"
  }, [_c('form', {
    staticClass: "u-form kiwi-channelinfo-basicmodes",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c('label', {
    staticClass: "kiwi-channelinfo-topic"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('channel_topic')))]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: _vm.topic,
      expression: "topic",
      modifiers: {
        "lazy": true
      }
    }],
    attrs: {
      "rows": "2",
      "readonly": !_vm.areWeAnOp
    },
    domProps: {
      "value": _vm.topic
    },
    on: {
      "change": function change($event) {
        _vm.topic = $event.target.value;
      }
    }
  })]), _vm.buffer.topics.length > 1 ? _c('div', {
    staticClass: "kiwi-channelinfo-previoustopics"
  }, [_c('a', {
    staticClass: "u-link",
    on: {
      "click": function click($event) {
        _vm.showPrevTopics = !_vm.showPrevTopics;
      }
    }
  }, [_vm._v(" Previous topics "), _c('i', {
    class: "fa fa-caret-".concat(_vm.showPrevTopics ? 'up' : 'down')
  })]), _vm.showPrevTopics ? _c('ul', _vm._l(_vm.prevTopics, function (topicText, idx) {
    return _c('li', {
      key: idx
    }, [_c('span', [_vm._v(_vm._s(topicText))])]);
  }), 0) : _vm._e()]) : _vm._e(), _c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('channel_moderated')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modeM,
      expression: "modeM"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.areWeAnOp
    },
    domProps: {
      "checked": Array.isArray(_vm.modeM) ? _vm._i(_vm.modeM, null) > -1 : _vm.modeM
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.modeM,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.modeM = (0, _concat.default)($$a).call($$a, [$$v]));
          } else {
            var _context;
            $$i > -1 && (_vm.modeM = (0, _concat.default)(_context = (0, _slice.default)($$a).call($$a, 0, $$i)).call(_context, (0, _slice.default)($$a).call($$a, $$i + 1)));
          }
        } else {
          _vm.modeM = $$c;
        }
      }
    }
  })]), _c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('channel_invite')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modeI,
      expression: "modeI"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.areWeAnOp
    },
    domProps: {
      "checked": Array.isArray(_vm.modeI) ? _vm._i(_vm.modeI, null) > -1 : _vm.modeI
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.modeI,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.modeI = (0, _concat.default)($$a).call($$a, [$$v]));
          } else {
            var _context2;
            $$i > -1 && (_vm.modeI = (0, _concat.default)(_context2 = (0, _slice.default)($$a).call($$a, 0, $$i)).call(_context2, (0, _slice.default)($$a).call($$a, $$i + 1)));
          }
        } else {
          _vm.modeI = $$c;
        }
      }
    }
  })]), _c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('channel_secret')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modeS,
      expression: "modeS"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.areWeAnOp
    },
    domProps: {
      "checked": Array.isArray(_vm.modeS) ? _vm._i(_vm.modeS, null) > -1 : _vm.modeS
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.modeS,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.modeS = (0, _concat.default)($$a).call($$a, [$$v]));
          } else {
            var _context3;
            $$i > -1 && (_vm.modeS = (0, _concat.default)(_context3 = (0, _slice.default)($$a).call($$a, 0, $$i)).call(_context3, (0, _slice.default)($$a).call($$a, $$i + 1)));
          }
        } else {
          _vm.modeS = $$c;
        }
      }
    }
  })]), _c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('channel_moderated_topic')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modeT,
      expression: "modeT"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.areWeAnOp
    },
    domProps: {
      "checked": Array.isArray(_vm.modeT) ? _vm._i(_vm.modeT, null) > -1 : _vm.modeT
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.modeT,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.modeT = (0, _concat.default)($$a).call($$a, [$$v]));
          } else {
            var _context4;
            $$i > -1 && (_vm.modeT = (0, _concat.default)(_context4 = (0, _slice.default)($$a).call($$a, 0, $$i)).call(_context4, (0, _slice.default)($$a).call($$a, $$i + 1)));
          }
        } else {
          _vm.modeT = $$c;
        }
      }
    }
  })]), _c('label', {
    staticClass: "u-checkbox-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('channel_external')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modeN,
      expression: "modeN"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.areWeAnOp
    },
    domProps: {
      "checked": Array.isArray(_vm.modeN) ? _vm._i(_vm.modeN, null) > -1 : _vm.modeN
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.modeN,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.modeN = (0, _concat.default)($$a).call($$a, [$$v]));
          } else {
            var _context5;
            $$i > -1 && (_vm.modeN = (0, _concat.default)(_context5 = (0, _slice.default)($$a).call($$a, 0, $$i)).call(_context5, (0, _slice.default)($$a).call($$a, $$i + 1)));
          }
        } else {
          _vm.modeN = $$c;
        }
      }
    }
  })]), _c('label', {
    staticClass: "kiwi-channelinfo-password"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('password')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: _vm.modeK,
      expression: "modeK",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "u-input",
    attrs: {
      "type": "text",
      "readonly": !_vm.areWeAnOp
    },
    domProps: {
      "value": _vm.modeK
    },
    on: {
      "change": function change($event) {
        _vm.modeK = $event.target.value;
      }
    }
  })])])]);
};
var staticRenderFns = exports.staticRenderFns = [];